import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { NodeViewWrapper, NodeViewContent, nodeViewProps } from '@tiptap/vue-3';


export default /*@__PURE__*/_defineComponent({
  __name: 'BlockNodeView',
  props: {
  ...nodeViewProps,
  extension: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

/*
  This is a custom node view for the block nodes which is used as a wrapper.
*/
const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NodeViewWrapper), {
    class: _normalizeClass([__props.extension.options.className, { 'ProseMirror-selectednode': _ctx.selected }, 'my-2']),
    "data-block-id": props?.node?.attrs?.['block-id']
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NodeViewContent), {
        as: __props.extension.options.tagName
      }, null, 8, ["as"])
    ]),
    _: 1
  }, 8, ["class", "data-block-id"]))
}
}

})